import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import { getColumnInfo } from "utils/bulkUploadColumnInfo";

const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: 600,
  color: "#133933",
  fontSize: "12px",
  borderBottom: "1px solid #EAEAEA",
  padding: "10px 20px",
});

export default function BulkUploadColumnGuide({ platform }) {
  const [open, setOpen] = useState(false);
  const columns = getColumnInfo(platform);
  if (!columns.length) return null;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "0.75rem" }}>
      <Box
        onClick={() => setOpen(true)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.25rem",
          cursor: "pointer",
          color: "#0077E7",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        <InfoOutlinedIcon fontSize="small" />
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          Column format guide
        </Typography>
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{ zIndex: 2100 }}
      >
        <StyledDialogTitle>Column Format Guide</StyledDialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <TableContainer sx={{ maxHeight: "50vh" }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Column</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Format</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Example</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {columns.map((column) => (
                  <TableRow key={column.name}>
                    <TableCell>{column.name}</TableCell>
                    <TableCell>{column.description}</TableCell>
                    <TableCell sx={{ fontStyle: "italic" }}>{column.example}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
